import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {AuthService} from './auth.service';

@Injectable()
export class AdminGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) { }

  checkLogin(url: string): boolean {
    if (this.authService.hasRole('administrator') || this.authService.hasRole('editor')) {
      return true;
    }

    // Navigate to the login page with extras
    this.router.navigate(['/not-authorized']);
    return false;
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;
    return this.checkLogin(url);
  }

  canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let url: string = state.url;
    return this.checkLogin(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/admin.guard.ts